<template>
  <div class="p-6">
    <h2 class="text-2xl">Settings</h2>
    <el-divider></el-divider>
    <div title="Toggle the state of order processing" class="flex items-center">
      <el-switch v-model="orderState" :disabled="disabled" :loading="loading" @change="toggleSate()"></el-switch>
      <div class="ml-6">
        <span>Order queue status</span>
        <div class="italic text-xs">
          [ {{ !orderState ? 'Orders are temporarily stopped from processing.' : 'All Orders are being processed.' }} ]
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ElNotification } from 'element-plus';
import { queueService } from '../services';

export default defineComponent({
  name: 'settingsComponent',
  data: function () {
    return {
      orderState: false,
      loading: false,
      disabled: false,
      callCount: 0,
    };
  },
  created() {
    this.retrieveState();
  },
  methods: {
    async retrieveState() {
      this.loading = true;
      this.disabled = true;
      try {
        const response = await queueService.getGlobalQueueState();
        this.orderState = response.status;
        this.disabled = false;
      } catch (e) {
        ElNotification({
          title: 'Error',
          type: 'error',
          message: 'Failed to retrieve queue state. Please try again later.',
          position: 'bottom-right',
        });
      }
      this.loading = false;
    },
    async toggleSate() {
      this.disabled = true;
      try {
        const response: { newStatus: boolean } = await queueService.updateGlobalQueueState();
        this.orderState = response.newStatus;
        this.disabled = false;
      } catch (e) {
        ElNotification({
          title: 'Error',
          type: 'error',
          message: 'Failed to update queue state. Please try again later.',
          position: 'bottom-right',
        });
      }
    },
  },
});
</script>

<style scoped></style>
